import StepContent from "./StepContent";
import StepTitle from "./StepTitle";

const Step = ({n,title,active,content, shipment}) => (
    <>
        <StepTitle  n={n} title={title} active={active}/>
        {active && <StepContent  active={active} content={content} step={n} shipment={shipment}/>}
    </>
  );
  
  export default Step;